import React, { Component } from 'react';
import { DraggableWindow } from '../DraggableWindow';
import { InputFile } from '../../../.common/InputFile/InputFile';

import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import { Divider } from '../../../.common/Divider/Divider';

import { KMLList } from './KMLList/KMLList';
import './KMLUploadTool.css'
import ApiOviewDocmd from '../../../../modules/WebApiModules/ApiOviewDocmd';
import { KMLAttributeOptionList } from './KMLAttributeOptionList/KMLAttributeOptionList';
export class KMLUploadTool extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.KMLScene;
        this.kmlOpenedStatus = {};
        this.state = {
            width: this.props.width,
            height: this.props.height,
            listHeight: parseInt(this.props.height) - 90,
            kmlList: [],
            showAttributes: this.getAttributeSetting(),
        }
    }

    componentDidMount() {
        this.Async_WaitMapInit().then(() => {
            this.updateKMLList();
        });
    }

    async Async_WaitMapInit() {
        if (window.gMainMap.IsReady) {
            return;
        }
        function Wait(time) {
            return new Promise((rs) => { setTimeout(rs, time ?? 100) })
        }
        while (!window.gMainMap.IsReady) {
            await Wait();
        }
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <DraggableWindow
                header="道路養護"
                content={this.content()}
                width={this.props.width}
                height={this.props.height}
                defaultPosition={this.props.defaultPosition}
                handleMinimize={this.props.handleMinimize}
                handleCancel={this.handleCancel}
                handleResize={this.handleResize}
                isShow={this.props.isShow} />
        );
    }

    content() {
        const { kmlUploadContext } = this.context;
        return (
            <div className='kmlUploadTool'>     
                <div className='kmlUploadTool__inputFile'>
                    <InputFile data={{accept: ".kml"}} onUploadClick={this.handleUploadingFile}/>
                </div>
                <Divider/>
                <div className='kmlUploadTool__container'>
                    <KMLList height={this.state.listHeight} data={{ list: kmlUploadContext.kmlList, showAttributes: this.state.showAttributes }} />
                    <KMLAttributeOptionList height={this.state.listHeight} data={this.state.showAttributes} onAttributesChange={this.onChange_showAttributesField.bind(this)} />
                </div>
            </div>
        );
    }    

    getAttributeSetting() {
        return {
            名稱: true,
            電話: true,
            地址: true,
            描述: true,
        };
    }

    onChange_showAttributesField(setting) {
        let obj = this.state.showAttributes;
        obj[setting.name] = setting.show;
        this.setState({showAttributes: obj});
    }

    updateKMLList = () => {
        const { kmlUploadContext } = this.context;
        ApiOviewDocmd.Docmd("CMD_ListKML", {}, /*success*/(res)=>{
            console.log(res);
            let kmlList = res.result.map((kml)=>{
                return kml.name;
            })
            kmlUploadContext.updateList(kmlList);
        }, /*failed*/console.log);
    }

    handleUploadingFile = (files) => {
        const { kmlUploadContext } = this.context;
        if (files.length > 0) {
            let file = files[0];
            // 上傳KML
            new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = function () {
                    let res = reader.result;
                    res = res.substring(res.indexOf('base64,') + 7, res.length);
                    resolve(res);
                }
                reader.readAsDataURL(file);
            }).then((uploadData)=>{
                let fileName = `${file.name.replace('.kml','')}(${new Date(Date.now()).toLocaleString('zh-TW', { timeZone: 'Asia/Taipei' }).replaceAll('/','-').replaceAll(':','.')}).kml`
                ApiOviewDocmd.Docmd("CMD_UploadKML", {name: fileName, content: uploadData}, /*success*/(res)=>{
                    kmlUploadContext.push({name: fileName, isOpened: true});
                }, /*failed*/console.log);
            }, console.log);
        }
    }

    handleCancel = ()=>{
        const { kmlUploadContext } = this.context;
        //全部關閉
        let newKmlList = kmlUploadContext.kmlList;
        for (let i = 0; i < newKmlList.length; i++) {
            newKmlList[i].isOpened = false;
        }
        kmlUploadContext.updateContextList(newKmlList);
        this.props.handleCancel();
    }

    handleResize = (width, height) => {
        let listHeight = parseInt(height) - 90;
        console.log(listHeight);
        this.setState({ width: width, height: height, listHeight: listHeight });
    }
}